<template>
    <views class="faq">
        <nav-bar
            title="常见问题"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="faq-search">
            <search-bar
                :path="path"
                :querys="querys"></search-bar>
        </views>
        <views class="faq-list">
            <van-list
                v-model="loadingData"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
                <faq-item
                    v-for="(item, index) in list"
                    :key="index"
                    :item="item">
                </faq-item>
            </van-list>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import SearchBar from '@/components/searchBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import FaqItem from './FaqItem'
export default {
    name: 'Faq',
    components: {
        NavBar,
        SearchBar,
        FaqItem
    },
    mixins: [tools],
    data() {
        return {
            pageNum: 1,
            loadingData: false,
            finished: false,
            keyword: '',
            list: []
        }
    },
    computed: {
        path() {
            return 'to=faq'
        },
        querys() {
            return this.$route.query || {}
        }
    },
    watch: {
        'querys.keyword': {
            handler(val) {
                this.keyword = val || ''
                this.reload()
            },
            immediate: true
        }
    },
    methods: {
        onClickLeft() {
            this.push('/person')
        },
        reload() {
            this.list = []
            this.finished = false
            this.loadingData = true
            this.onLoad()
        },
        onLoad() {
            const params = {
                page: this.pageNum,
                page_size: 10
            }
            if (this.keyword) params.question = this.keyword
            api.getFaqList(params).then((res) => {
                if (res.data.list && res.data.list.length > 0) {
                    res.data.list.forEach((item) => {
                        this.list.push({ ...item })
                    })
                    this.loadingData = false
                    this.pageNum++
                } else {
                    this.finished = true
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
